module.exports = __webpack_public_path__ + "static/media/prepTraining.ff14c618.svg";